module.exports = __webpack_public_path__ + "img/map2.7516209a.png";